import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import SpecialCard from './SpecialCard';
import SpecialCardSingle from './SpecialCardSingle';
import MenuFind from '../../components/MenuFind';

const styles = css`
  .Special_list {
    padding: 50px 0;
    @media(min-width: 992px) {
      padding: 80px 0;
    }
  }
`;

function SpecialOffers({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        page={page}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuFind />
      <div className="container Special_list">
        {
          get(page, 'special', []).filter(special => special.published).length > 1 &&
          <div className="d-flex flex-wrap justify-content-center">
            {
              get(page, 'special', []).map(item => (
                <SpecialCard special={item} key={item._id} />
              ))
            }
          </div>
        }
        {
          get(page, 'special', []).filter(special => special.published).length === 1 &&
          <div className="d-flex flex-wrap justify-content-center">
            {
              get(page, 'special', []).map(item => (
                <SpecialCardSingle special={item} key={item._id} />
              ))
            }
          </div>
        }
        {
          !get(page, 'special', []).filter(special => special.published).length === 0 &&
          <div className="d-flex flex-wrap justify-content-center">
            There are no special offers available at this time. Please check back soon or&nbsp;<Link name="contact-us">contact us</Link>&nbsp;for more information.
          </div>
        }
      </div>
    </PageWrapper>
  );
}

SpecialOffers.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'special_offers',
})(SpecialOffers);



// WEBPACK FOOTER //
// ./src/pages/SpecialOffers/index.js